'use strict';

const base = require('base:product/quickView');
var focusHelper = require('../components/focus');
const attributesLogic = require('attributes');

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));
    return $html.find('.product-quickview');
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = ''
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span class="close-btn"></span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';

    var $modalEl = $(htmlString);
    $modalEl.on('shown.bs.modal', function () {
        // this event will be catched to be used to initialize slick slider
        $('body').trigger('quickview:ready', $modalEl);
    });
    $('body').append($modalEl);
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 * @param {string} productGtm - GTM
 */
function fillModalElement(selectedValueUrl, productGtm) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            var $quickViewModal = $('#quickViewModal');

            $quickViewModal.find('.modal-body').empty().html(parsedHtml).find('.quick-view-carousel-area')
                .addClass('d-none');
            $('.full-pdp-link').text(data.quickViewFullDetailMsg);
            $('.full-pdp-link', $quickViewModal).attr('href', data.productUrl);
            $('.size-chart', $quickViewModal).attr('href', data.productUrl);
            $('.modal-header .close .sr-only', $quickViewModal).text(data.closeButtonText);
            $('.enter-message', $quickViewModal).text(data.enterDialogMessage);
            $('#quickViewModal').attr('data-product-gtm', JSON.stringify(productGtm));
            $quickViewModal.modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}
/**
 * Adjust the add-to-cart button
 * @param {Object} disableButton - disable button add to cart
 */
function updateAddToCartButton(disableButton) {
    const $addToCartButton = $('button.add-to-cart-global');
    $addToCartButton.attr('disabled', disableButton);

    const $section = $addToCartButton.closest('.add-to-cart-section');

    if ($section.length > 0) {
        if (disableButton) {
            $addToCartButton.text($section.attr('data-text-choose'));
        } else {
            $addToCartButton.text($section.attr('data-text-ready'));
        }
    }
}

/**
 * Init events for quickView
 */
function initQuickViewLogic() {
    // Init event on document ready
    $(function () {
        var $body = $('body');
        $body.on('click', '.product-attributes-section .attribute.toggle', attributesLogic.toggleAttribute);
        $body.on('click', '.attribute-values .circle-unselected', attributesLogic.selectAttributeValue);

        $body.on('product:updateAddToCart', function (e, response) {
            const disableButton = (!response.product.readyToOrder || !response.product.available);
            updateAddToCartButton(disableButton);
        });
        $body.on('quickview:ready', function (e, response) {
            $('.alert-incompatible-shipping-methods').html($('#incompatible-shipping-methods-message-holder').html());

            var $carousel = $();
            var $modal = $(response);

            if ($modal.length) {
                $carousel = $modal.find('.quick-view-carousel-area .detail-slider-nav.detail-desktop-images.quickview-carousel');
            } else {
                $carousel = $('.quick-view-carousel-area .detail-slider-nav.detail-desktop-images.quickview-carousel');
            }

            $carousel.on('init', function () {
                $modal.find('.quick-view-carousel-area').removeClass('d-none');
            });

            $carousel.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                focusOnSelect: true,
                infinite: false,
                arrows: true
            });
        });
    });
}

module.exports = {
    getModalHtmlElement,
    initQuickViewLogic,
    showQuickview: function () {
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var selectedValueUrl = $(this).attr('href');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            var $productGtm = $($(this).closest('.product-tile')[0]).data('productGtm');
            fillModalElement(selectedValueUrl, $productGtm);
        });
    },
    focusQuickview: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal .close').focus();
        });
    },
    trapQuickviewFocus: function () {
        $('body').on('keydown', '#quickViewModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    availability: base.availability,
    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.modal-content').spinner().start();
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function () {
            $('#quickViewModal').modal('hide');
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelect', function () {
            $('.modal.show .modal-content').spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .full-pdp-link')
                    .attr('href', response.data.product.selectedProductUrl);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.add-to-cart-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order')
                || !$('.global-availability', dialog).data('available'));
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);

            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    }
};
